import { updateBook } from "../actions";

const updater = (item) => {
  return async (dispatch) => {
    const response = await fetch(`http://localhost:9000/books/${item.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(item),
    });
    const book = await response.json();

    dispatch(updateBook(book));
  };
};

export default updater;
